<div class="legend-wrapper">
  <div class="legend-device-wrapper" *ngFor="let device of devicesWithSeries; let i = index">
    <div class="legend-device-title-wrapper">
      <div class="legend-device-title">
        {{
          device.shortDeviceName ||
            ('+INSTALLATIONS.INSTALLATION.CASCADES.MULTIVALENT.DEVICE.' +
              device.deviceType.toUpperCase() | translate) +
              ' ' +
              (i + 1)
        }}
      </div>
      <div>
        {{ device?.boilerSerial !== total ? device?.boilerSerial : '' }}
      </div>
      <div class="categories-wrapper" *ngIf="getCategoryNameListByDeviceId(device.deviceId)">
        <ng-container *ngFor="let category of getCategoryNameListByDeviceId(device.deviceId)">
          <button
            *ngIf="category.isShow"
            class="flex-1 w-[100px] py-2 font-semibold text-center rounded-md border border-gray-300 opacity-50 hover:opacity-100 transition focus:outline-none active:bg-gray-100 active:opacity-100"
            [class.category-active]="category.active"
            (click)="onSelectCategory(device.deviceId, category)"
          >
            {{ category.categoryName }}
          </button>
        </ng-container>
      </div>
    </div>
    <div class="legend-features-wrapper">
      <ng-container *ngFor="let series of device.data">
        <div
          class="legend-feature"
          (click)="onItemLegendClick(series)"
          [class.legend-feature--hidden]="!series.visible"
        >
          <span class="legend-feature-indicator" [style.background-color]="series.color"></span>
          <div
            class="legend-feature-description"
            [matTooltip]="series.name"
            matTooltipPosition="above"
            #tooltipElement
            [matTooltipDisabled]="isTooltipDisabled(tooltipElement)"
          >
            {{ series.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
